import api_access from '../../../api/apiInstance';
import { FETCH_EXTERNAL_USERS } from '../../../utils/constants';
import type {
  EncompassExternalUser,
  EncompassExternalUsersResponse,
  QueryExternalUsersOptions,
} from '../models/ExternalUsers';

export async function fetchExternalUsers(
  options: QueryExternalUsersOptions = {},
): Promise<EncompassExternalUser[]> {
  try {
    const response = await api_access.get<EncompassExternalUsersResponse>(
      FETCH_EXTERNAL_USERS,
      { params: options },
    );

    return response.data.encompassExternalUsers;
  } catch (error) {
    console.error('Error fetching external users:', error);
    throw error;
  }
}
